export class DocumentTreeResultDto {
  communityId: number;
  customerId: string;
  id: string;
  parentId: string;
  text: string;
  category: string;
  subcategory: string;
  year: string;
  month: string;
  fileCount: number;
  path: string;
}
